// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__15qZv","usual":"styles_usual__3mNNR","seamless":"styles_seamless__2Cc9d","has_icon":"styles_has_icon__1bzrG"};